import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { ReplicatedInfoDelegate } from 'store/modules/dynamic-form/replicatedInfoDelegate';
import {
  AdditionalContactInformationFormFields,
  DDARAdditionalContactInformation,
} from 'store/modules/dynamic-form/DDAR/additionalContactsInformationDelegate';
import ReplicatedInfo from '../../ReplicatedInfoV2';

interface Props {
  delegate: ReplicatedInfoDelegate<DDARAdditionalContactInformation, AdditionalContactInformationFormFields> | null;
}

const onlineEnrollmentOptions: OptionType[] = [
  { label: 'View Only', value: 'View Only' },
  { label: 'View & Edit', value: 'View & Edit' },
];

const toolkitUserAccess: OptionType[] = [
  { label: 'None', value: 'None' },
  { label: 'Bills: View & Pay', value: 'Bills: View & Pay' },
];

const ContactFormFields: React.FC = observer(() => {
  return (
    <>
      <IMInputText label="Name" name="fullName" maxLength={50} />
      <IMInputText label="Email" name="email" maxLength={50} />
      <IMInputText label="Business Phone" name="businessPhone" />
      <IMInputText label="Cell Phone" name="cellPhone" />
      <IMSelect label="Employer Toolkit User Access" name="toolkitAccess" options={toolkitUserAccess} />
      <IMSelect label="Online Enrollment" name="onlineEnrollment" options={onlineEnrollmentOptions} />
    </>
  );
});

const DDARAdditionalContactsInformation: React.FC<Props> = observer(({ delegate }) => {
  return delegate ? (
    <ReplicatedInfo
      delegate={delegate}
      modalItemTitle="Additional Contact Information"
      addButtonLabel="Include Additional Contact"
      columns={[
        {
          title: 'Name',
          width: '14rem',
          getValue: (info) => info.fullName ?? '',
        },
        {
          title: 'Email',
          width: '15rem',
          getValue: (info) => info.email ?? '',
        },
        {
          title: 'Toolkit Access',
          width: '11rem',
          getValue: (info) => info.toolkitAccess ?? '',
        },
        {
          title: 'Online Enrollment',
          width: '12rem',
          getValue: (info) => info.onlineEnrollment ?? '',
        },
      ]}
      addItemFormFields={<ContactFormFields />}
      editItemFormFields={<ContactFormFields />}
    />
  ) : null;
});

export default DDARAdditionalContactsInformation;
